import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';

import type { BackgroundToken } from '@core/theme-util';
import type { IconName, IconSize, IconToken } from '@core/user-interface-legacy';
import { IconComponent } from '@core/user-interface-legacy';
import { tokenToCssVar } from '@core/utils-legacy';

export type IconCircleSize = 'small' | 'medium' | 'default' | 'large';

type ComponentSizes = { componentSize: IconCircleSize; iconSize: IconSize };

function resolveSizes(iconCircleSize: IconCircleSize): ComponentSizes {
  return {
    componentSize: iconCircleSize,
    iconSize: resolveIconSize(iconCircleSize),
  };
}

function resolveIconSize(size: IconCircleSize): IconSize {
  switch (size) {
    case 'small':
    case 'medium':
      return 'small-x';
    default: {
      return 'small';
    }
  }
}

@Component({
  selector: 'rt-icon-circle',
  templateUrl: './icon-circle.component.html',
  styleUrls: ['./icon-circle.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  host: {
    '[class]': 'size().componentSize',
    '[style.background-color]': 'tokenToCssVar(backgroundColor())',
  },
})
export class IconCircleComponent {
  public readonly tokenToCssVar = tokenToCssVar;

  public readonly backgroundColor = input<BackgroundToken>('colorBgNeutralDefault');
  public readonly iconColor = input.required<IconToken>();
  public readonly size = input.required<ComponentSizes, IconCircleSize>({
    transform: resolveSizes,
  });
  @Input({ required: true }) public iconName: IconName;
}
